
export const CheckOutFormStepDesc = (props: {
    children: React.ReactNode;
}) => {
    return (
        <p className="-mt-4 text-sm header-font font-light text-gray-500">
            {props.children}
        </p>
    );
};